import { NewControlProgramTag, NewUserTag } from "api/generated/model";
import { Guid } from "utils/guid";

import { ControlProgramTag, UserTag } from "./types";

export function isUserTagActive(tag: UserTag): boolean {
    return tag.active;
}

export function isControlProgramTagActive(_tag: ControlProgramTag): boolean {
    return true;
}

export function getUserTagCategoryId(tag: UserTag): Guid {
    return tag.tagCategoryId;
}

export function getControlProgramTagCategoryId(tag: ControlProgramTag): Guid {
    return tag.controlProgramTagCategoryId;
}

export function createNewUserTag(name: string, categoryId: string): NewUserTag {
    return {
        name,
        tagCategoryId: categoryId,
    };
}

export function createNewControlProgramTag(
    name: string,
    categoryId: string
): NewControlProgramTag {
    return {
        name,
        controlProgramTagCategoryId: categoryId,
    };
}
